import classnames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import { ROUTE_ITINERARY_ROADBOOK } from '../../routes'
import {
  selectAddressKeywords,
  selectGeoentityAdsKeywords,
  selectItineraryKeywords,
  selectShouldDisplayGeoentityAd,
} from '../../store/ad/ad.selectors'
import { selectCurrentHistoryRoute } from '../../store/history/history.selectors'
import { isGE } from '../Device'
import AdLoader from './AdLoader'
import s from './InlineDesktopAdBanner.less'
import { withEverySelectorTruthy } from '../utils/react-redux'

const DEFAULT_PLACEHOLDER = { width: 300, height: 250 }
const EXPENSE_REPORT_TOP_PLACEHOLDER = { width: 728, height: 90 }

const InlineDesktopAdBanner = ({ adName, keywordsSelector, placeHolder, className }) => {
  if (__SERVER__ || (__BROWSER__ && isGE())) {
    return (
      <div className={classnames(s.container, className)}>
        <AdLoader adName={adName} keywordsSelector={keywordsSelector} className={s.content} placeHolder={placeHolder} />
      </div>
    )
  }
  return <></>
}

export const AdDesktopBannerHP = () => (
  <InlineDesktopAdBanner adName="hp_banner_desktop" placeHolder={DEFAULT_PLACEHOLDER} />
)

export const AdDesktopAddress = () => (
  <InlineDesktopAdBanner
    adName="address_rectangle_desktop"
    keywordsSelector={selectAddressKeywords}
    placeHolder={DEFAULT_PLACEHOLDER}
  />
)

export const AdDesktopItineraryHP = () => (
  <InlineDesktopAdBanner adName="hp_itinerary_banner_desktop" placeHolder={DEFAULT_PLACEHOLDER} />
)

export const AdDesktopRectangleItineraryResult = () => {
  const route = useSelector(selectCurrentHistoryRoute)
  const adName =
    route === ROUTE_ITINERARY_ROADBOOK
      ? 'roadbook_routelist_rectangle_desktop'
      : 'itinerary_routelist_rectangle_desktop'

  return (
    <InlineDesktopAdBanner
      adName={adName}
      className={s.AdDesktopRectangleItineraryResult}
      keywordsSelector={selectItineraryKeywords}
      placeHolder={DEFAULT_PLACEHOLDER}
    />
  )
}

export const AdDesktopExpenseReportBanner = ({ className }) => (
  <InlineDesktopAdBanner
    adName="expense_report_banner"
    keywordsSelector={selectItineraryKeywords}
    className={className}
    placeHolder={EXPENSE_REPORT_TOP_PLACEHOLDER}
  />
)

export const AdDesktopExpenseReportRectangleRight = ({ className }) => (
  <InlineDesktopAdBanner
    adName="expense_report_rectangle_right"
    keywordsSelector={selectItineraryKeywords}
    className={className}
  />
)

export const AdDesktopExpenseReportRectangleLeft = ({ className }) => (
  <InlineDesktopAdBanner
    adName="expense_report_rectangle_left"
    keywordsSelector={selectItineraryKeywords}
    className={className}
  />
)

export const AdDesktopRectangleGeoentity = withEverySelectorTruthy(selectShouldDisplayGeoentityAd)(() => (
  <InlineDesktopAdBanner
    adName="poi_rectangle_desktop"
    keywordsSelector={selectGeoentityAdsKeywords}
    placeHolder={DEFAULT_PLACEHOLDER}
  />
))
